"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var MetaInfo = function MetaInfo(props) {
  var _ref = props || {},
      user = _ref.user,
      replyCount = _ref.replyCount;

  var _ref2 = user || {},
      rank = _ref2.rank,
      userTitle = _ref2.userTitle,
      reputation = _ref2.reputation;

  var _ref3 = reputation || {},
      rankName = _ref3.rank;

  var repliesMade = replyCount !== null && replyCount !== void 0 ? replyCount : reputation === null || reputation === void 0 ? void 0 : reputation.repliesMade;
  var userRankTitle = userTitle !== null && userTitle !== void 0 ? userTitle : rankName;
  return (0, _preact.h)("div", {
    className: "post__user__meta"
  }, (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta')
  }, (0, _preact.h)("li", null, (0, _preact.h)("div", {
    className: "group--inline"
  }, (0, _preact.h)(_UserName.default, {
    user: user,
    extraClass: "username"
  }), (rank === null || rank === void 0 ? void 0 : rank.iconUrl) && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(rank.iconUrl),
    className: "usericon qa-latest-poster-usericon",
    alt: rank === null || rank === void 0 ? void 0 : rank.name
  }))), userRankTitle && (0, _preact.h)("li", {
    className: "list-item--no-dot is-hidden-S"
  }, (0, _preact.h)("span", {
    title: userRankTitle,
    className: (0, _classnames.default)('usertitle qa-usertitle default-cursor')
  }, userRankTitle)), !!(repliesMade && repliesMade > 0) && (0, _preact.h)("li", {
    className: "is-hidden-S"
  }, (0, _preact.h)(_phrase.default, {
    p: "topic.meta.post.reply",
    count: {
      n: repliesMade.toString()
    }
  }))));
};

var _default = MetaInfo;
exports.default = _default;